import { App as AntdApp, ConfigProvider } from 'antd';
import enUS from 'antd/locale/en_US';
import type { ReactNode } from 'react';

import { adminTheme } from '@/config/theme';

/**
 * Toasts open below the page's own top-right action row (ADO 110943). antd's default
 * `top: 24` puts a notification directly over a module header's primary button — Create
 * Customer, Add Device — so the admin cannot press it while a toast is visible. 80px clears
 * the content card's top margin (16) + `<PageContainer>`'s padding (24) + the 40px header row.
 */
const NOTIFICATION_CONFIG = { top: 80 };

export function AntdConfigProvider({ children }: { children: ReactNode }) {
  return (
    <ConfigProvider locale={enUS} theme={adminTheme}>
      <AntdApp notification={NOTIFICATION_CONFIG}>{children}</AntdApp>
    </ConfigProvider>
  );
}
